/**
 * validators.js — Regole di validazione dei dati di prenotazione.
 * Mirror della logica canGo() in btn_step_page_widget.dart.
 */
const Validators = {

    // ── Primitivi ───────────────────────────────────────────────
    email(v)  { return !!v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); },
    name(v)   { return !!v && v.trim().length >= 3; },
    cf(v)     { return !!v && v.trim().length === 16; },
    mobile(v) { return !!v && v.trim().length >= 6; },

    // "dd/mm/yyyy" + "HH:MM" → Date (null se invalida)
    itToDate(date, time = '00:00') {
        if (!date) return null;
        const p = date.split('/');
        if (p.length !== 3) return null;
        const y = p[2].length === 2 ? '20' + p[2] : p[2];
        const d = new Date(`${y}-${p[1]}-${p[0]}T${time}:00`);
        return isNaN(d) ? null : d;
    },

    // ── Step 1 ──────────────────────────────────────────────────
    step1() {
        const s = BookingState;

        if (!s.reservation_type)
            return 'Seleziona una modalità di viaggio valida.';

        if (!s.start_date || !s.start_time)
            return 'Inserisci data e orario di partenza.';

        const startDt = this.itToDate(s.start_date, s.start_time);
        if (!startDt)
            return 'Data di partenza non valida.';

        if ((startDt - new Date()) / 3600000 < ENV.MIN_BOOKING_HOURS)
            return `La data/ora di partenza deve essere successiva a ${ENV.MIN_BOOKING_HOURS} ore da adesso.\n`
                 + `Per prenotazioni urgenti chiama ${ENV.CONTACT_PHONE} oppure scrivi a ${ENV.CONTACT_EMAIL}.`;

        if (s.reservation_type !== 'andata') {
            if (!s.return_date || !s.return_time)
                return 'Inserisci data e orario di ritorno.';
            const retDt = this.itToDate(s.return_date, s.return_time);
            if (!retDt)
                return 'Data di ritorno non valida.';
            if ((retDt - startDt) / 3600000 > ENV.MAX_RETURN_DELTA_H)
                return `La data/ora di ritorno deve essere inclusa nelle ${ENV.MAX_RETURN_DELTA_H} ore dalla data di partenza.`;
        }

        if (!s.start_address || !s.start_address_lat)
            return "Seleziona l'indirizzo di partenza dalla lista dei suggerimenti.";
        if (!s.end_address || !s.end_address_lat)
            return "Seleziona l'indirizzo di arrivo dalla lista dei suggerimenti.";
        if (!s.start_address_opts.type || s.start_address_opts.type === 'Seleziona')
            return 'Seleziona la tipologia del luogo di partenza.';
        if (!s.end_address_opts.type || s.end_address_opts.type === 'Seleziona')
            return 'Seleziona la tipologia del luogo di arrivo.';

        return null;
    },

    // ── Step 2 ──────────────────────────────────────────────────
    step2() {
        if ((BookingState.seat + BookingState.seat_guest) < 1)
            return 'Inserisci almeno un passeggero.';
        return null;
    },

    // ── Dati cliente (step 3) ────────────────────────────────────
    clientData() {
        const c = BookingState.client;
        if (!this.name(c.name))     return 'Nome non valido (minimo 3 caratteri).';
        if (!this.name(c.lastname)) return 'Cognome non valido (minimo 3 caratteri).';
        const cfRequired = !c.address_country || c.address_country === 'IT';
        if (cfRequired && !this.cf(c.cf))
            return 'Codice fiscale non valido (deve essere di 16 caratteri).';
        if (!cfRequired && c.cf && !this.cf(c.cf))
            return 'Codice fiscale non valido (deve essere di 16 caratteri).';
        if (!c.address)             return "Inserisci l'indirizzo di residenza.";
        if (!this.email(c.email))   return 'Email non valida.';
        if (!this.mobile(c.phone))  return 'Numero di telefono non valido.';
        if (c.privacy !== '1')
            return "Devi accettare l'informativa sulla privacy e i termini e condizioni.";
        return null;
    },

    // ── Prerequisito per chiamare getAvailableReservation ────────
    canCheckAvailability() {
        const s = BookingState;
        if (!s.reservation_type || !s.start_date || !s.start_time) return false;
        if (s.reservation_type !== 'andata' && (!s.return_date || !s.return_time)) return false;
        const startDt = this.itToDate(s.start_date, s.start_time);
        if (!startDt) return false;
        return (startDt - new Date()) / 3600000 >= ENV.MIN_BOOKING_HOURS;
    },
};
